import { Component, type ReactNode } from 'react'
import { useTranslation } from '@/services/i18n'

class LoadBoundary extends Component<{
  children: ReactNode
  message: string
  retry: string
}, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() { return { failed: true } }
  render() {
    if (!this.state.failed) return this.props.children
    return <div role="alert" className="fixed inset-0 z-50 grid place-content-center gap-4 bg-slate-950 p-6 text-center text-white">
      <p>{this.props.message}</p>
      <button className="cursor-pointer rounded-full bg-amber-500 px-6 py-3 font-display" onClick={() => window.location.reload()}>
        {this.props.retry}
      </button>
    </div>
  }
}

/** A failed on-demand chunk or data request must offer recovery, not a blank app. */
export function ContentBoundary({ children }: { children: ReactNode }) {
  const { t } = useTranslation()
  return <LoadBoundary message={t('common.loadFailed')} retry={t('common.retry')}>{children}</LoadBoundary>
}

export function ContentLoading() {
  const { t } = useTranslation()
  return <div role="status" className="fixed inset-0 z-50 grid place-content-center bg-black/70 text-white">
    <p className="rounded-2xl bg-slate-900 px-6 py-4">{t('common.loading')}</p>
  </div>
}
